export const formDeadlineSchema = [
  { fieldName: 'date', type: 'DatePicker', label: 'Set deadline for providing the docs', required: true },
];
